<template>
  <div class="nav-tab-container">
    <div
      v-for="item in navOptions"
      :key="item.value"
      class="nav-tab"
      :class="{'nav-active-tab' : searchObject.includeType === item.value}"
      @click="$emit('option-changed', item.value)"
    >
      <span>{{ item.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      navOptions: [
        { text: 'Include', value: 0 },
        { text: 'Show Only', value: 1 }
      ],
      active: 0
    }
  },

  computed: {
    ...mapState('common', ['searchObject'])
  }
}
</script>

<style lang="sass" scoped>
.nav-tab-container
  display: flex
  flex-flow: row
  justify-content: space-evenly
  padding-top: 1rem
  padding-left: 1rem

.nav-tab
  font-size: 1.4rem
  font-weight: 500
  color: $hwayzShadow
  span
    cursor: pointer
  &.nav-active-tab
    border-bottom: 0.1rem solid $hwayzDarkGray
    color: $hwayzBlack
</style>
